import { Pagination } from "@heroui/react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export default function Paginate({ links = [] }) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(search);
  const currentPage = parseInt(queryParams.get("page"), 10) || 1;

  const handlePageChange = (pageNumber) => {
    navigate(`${pathname}?page=${pageNumber}`);
  };

  const getTotalPages = () => {
    try {
      const pageNumbers = links
        .map((link) => parseInt(link.label, 10))
        .filter((num) => !isNaN(num));

      return pageNumbers.length ? Math.max(...pageNumbers) : 1;
    } catch (error) {
      console.error("Error calculating total pages:", error);
      return 0;
    }
  };

  return (
    <div className="!-z-10 flex justify-center items-center mt-5 mb-5 rtl space-x-4">
      <Pagination
        className={"!z-0"}
        initialPage={1}
        page={currentPage}
        size={"lg"}
        total={getTotalPages()}
        onChange={(page) => {
          handlePageChange(page);
        }}
      />
    </div>
  );
}

Paginate.propTypes = {
  links: PropTypes.array,
};

Paginate.defaultProps = {
  links: [],
};